import Base from "@/api/Base";

export default class Legitimate extends Base
{
	setType (v)
	{
		this.data.type = v;
		return this;
	}

	setValue (v)
	{
		this.data.value = v;
		return this;
	}

	setRemoveMustReconfirmMobilePhoneOnSuccess (v)
	{
		this.data.removeMustReconfirmMobilePhoneOnSuccess = v;
		return this;
	}

	setRemoveMustReconfirmSearchPermissionOnSuccess (v)
	{
		this.data.removeMustReconfirmSearchPermissionOnSuccess = v;
		return this;
	}

	setPublishJobProfileIfPossible (v)
	{
		this.data.publishJobProfileIfPossible = v;
		return this;
	}

	getMethod ()
	{
		return 'PATCH';
	}

	getUrl ()
	{
		return '/kunde/legitimierung';
	}
}
